import { testimonials } from '@/mocks/testimonials';

function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            真實用戶評價
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            來自不同年齡層的真實用戶分享，聽聽他們怎麼說
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-background-100/70 rounded-lg p-6 flex flex-col cursor-default">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900">{t.name}</h4>
                  <p className="text-xs text-foreground-500">{t.age}歲 · {t.occupation}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{t.content}</p>
              <p className="text-xs text-foreground-400 mt-4 pt-4 border-t border-background-200/60">{t.usageDuration}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/articles"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多用戶故事
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;